'use client';

import { useEffect } from 'react';
import { prefetchCriticalImages } from '@/lib/imageOptimization';

// Add type declaration for window.gtag
declare global {
  interface Window {
    gtag?: (command: string, action: string, params: any) => void;
  }
}

/**
 * ClientOptimizers - A client component that runs optimization scripts
 * This component doesn't render any UI but improves performance
 */
export default function ClientOptimizers() {
  useEffect(() => {
    // Prefetch critical images based on current route
    prefetchCriticalImages();

    // Mark the performance entry point for LCP
    if (typeof window !== 'undefined' && 'performance' in window) {
      // Use performance mark to help debugging
      performance.mark('lcp-optimizations-applied');

      // Register LCP observer
      if ('PerformanceObserver' in window) {
        const lcpObserver = new PerformanceObserver((entryList) => {
          const entries = entryList.getEntries();
          if (entries.length > 0) {
            // Log LCP time for debugging (remove in production)
            console.debug('LCP:', entries[0].startTime);
            
            // Send to analytics if needed
            if (window.gtag) {
              window.gtag('event', 'lcp_timing', {
                value: Math.round(entries[0].startTime),
                metric_id: 'lcp',
                metric_value: Math.round(entries[0].startTime),
                metric_delta: 0,
              });
            }
          }
        });
        
        lcpObserver.observe({ type: 'largest-contentful-paint', buffered: true });
      }
    }
    
    // Cleanup
    return () => {
      // Clear any observers if needed
    };
  }, []);

  // This component doesn't render anything
  return null;
} 